import store from '~/store'

export default async (to, from, next) => {
  if (store.getters['auth/check']) {
    let user = store.getters['auth/user'];
    next({ name: 'settings.profile', params: { id: user.id } });
  } else {
    next();
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/guest.js